<template>
  <div class="cost-estimator-footer__estimate-amount">
    {{yield}}
  </div>
</template>
